export const API_UNUSED_DATA_CACHE_SECONDS = 120;
